import React from 'react';
import PriceSection from './PriceSection/PriceSection';
import CustomerSection from './CustomerSection/CustomerSection';
import HeroSection from './HeroSection/HeroSection';
import MainSection from './MainSection/MainSection';
import InvestmentSection from './InvestmentSection/InvestmentSection';
import SupportSection from './SupportSection/SupportSection';
import BlogSection from './BlogSection/BlogSection';
import Footer from './Footer/Footer';

const Homepage = () => {
    return (
        <div>
            <HeroSection />
            <MainSection />
            <CustomerSection />
            <PriceSection />     
            <InvestmentSection />
            <SupportSection />       
            <BlogSection />
            <Footer />
        </div>
    )
}

export default Homepage
